import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './aa909b7d2b73a8b22d3cf3b03055043e65f7266a3134d7e479abd1c59af0f41c.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';

var _excluded = ["background", "children", "className", "inverted", "show", "size", "role", "aria-label", "aria-live", "aria-hidden"];
var LoadingSpinner = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'fade' : _ref$background,
    children = _ref.children,
    className = _ref.className,
    _ref$inverted = _ref.inverted,
    inverted = _ref$inverted === void 0 ? false : _ref$inverted,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'progressbar' : _ref$role,
    ariaLabel = _ref['aria-label'],
    _ref$ariaLive = _ref['aria-live'],
    ariaLive = _ref$ariaLive === void 0 ? 'polite' : _ref$ariaLive,
    ariaHidden = _ref['aria-hidden'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var defaultAriaLabel = translate('loading');
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.spinnerContainer, _defineProperty({}, styles[size], !children))
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.spinnerComponent, styles[size], _defineProperty(_defineProperty({}, styles.inverted, inverted), styles.hide, !show)),
    "data-loadingspinner": show || undefined,
    role: role,
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : defaultAriaLabel,
    "aria-live": ariaLive,
    "aria-hidden": ariaHidden
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null))), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.spinnerContent, _defineProperty(_defineProperty({}, styles[background], show), styles.disablePointerEvents, show))
  }, children));
});

export { LoadingSpinner as default };
